import { createAction } from '@reduxjs/toolkit';

//=======addFilterAction======//
export const addFilter = createAction('contacts/addFilter');
